import React from 'react';
/*import 'font-awesome/css/font-awesome.min.css';*/

const LoadingSpinner = () => (
    <div>
       <i className="fa fa-spinner fa-spin mx-2 my-2" /> Loading...
    </div>
);

export default LoadingSpinner;
